import { BrowserLanguage } from '~/features/i18n/types/browserLanguage'

export function getBrowserLanguage(): string {
  if (typeof window === 'undefined') return ''

  const browserLanguage = window.navigator.language as BrowserLanguage
  const lang = browserLanguage.split('-')[0]

  return lang
}
